export const planes = [
  {
    plan: "Colaboraciones",
    precio:"$5.000",
    beneficios:["Nombramiento redes","Sticker"]
  },
  {
    plan: "Colaboraciones",
    precio:"$10.000",
    beneficios:["Nombramiento redes","Sticker","Llavero"]
  },
  {
    plan: "Colaboraciones",
    precio:"$25.000",
    beneficios:["Nombramiento redes","Sticker","Llavero","Poster"]
  },
  {
    plan: "Colaboraciones",
    precio:"$50.000",
    beneficios:["Nombramiento redes y corto","Sticker","Llavero","Poster","Cena"]
  },
  {
    plan: "Colaboraciones",
    precio:"$100.000",
    beneficios:["Nombramiento redes y corto","Sticker","Llavero","Poster","1 día rodaje"]
  },
  {
    plan: "Sponsor",
    precio:"$150.000",
    beneficios:["Nombramiento redes y corto","Créditos poster"]
  },
  {
    plan: "Sponsor",
    precio:"$250.000",
    beneficios:["Nombramiento redes y corto","Créditos poster","Contenido del progreso"]
  }
]